import { render } from "./worksheetRequired.vue?vue&type=template&id=3252fee8&scoped=true&ts=true"
import script from "./worksheetRequired.vue?vue&type=script&lang=ts"
export * from "./worksheetRequired.vue?vue&type=script&lang=ts"

import "./worksheetRequired.vue?vue&type=style&index=0&id=3252fee8&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3252fee8"]])

export default __exports__